import { getTheme, Icon, mergeStyles, Text } from "@fluentui/react";
import { PRIVATE_GET_STYLE_CLASSES } from "./styles";

interface IAppHeaderButtonProps {
    icon?: string;
    text?: string;
    showNotification?: boolean;
    onClick: () => void;
}

export const AppHeaderButton: React.FunctionComponent<IAppHeaderButtonProps> = (props) => {
  const theme = getTheme();
  const styles = PRIVATE_GET_STYLE_CLASSES(theme);

  const icon = !props.icon && !props.text ? 'Unknown' : props.icon;
  const iconStyle = [styles.icon];
  const iconClassName = mergeStyles(iconStyle);

  return (
    <button className={styles.button} onClick={props.onClick}>
      {!!icon && <Icon iconName={icon} className={iconClassName} />}
      {!!props.text && <Text variant="mediumPlus">{props.text}</Text>}
      {props.showNotification === true && <div className={styles.notificationIndicator}></div>}
    </button>
  );
  };